import cn from 'classnames';
import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import s from './text.module.css';

interface Props {
  children: ReactNode;
  className?: string;
  replaceBehavior?: 'hide' | 'ellipse';
}

export const Text: FC<Props> = ({ children, className, replaceBehavior = 'ellipse' }) => {
  const ref = useRef<HTMLSpanElement | null>(null);

  const [isCut, setIsCut] = useState(true);

  useEffect(() => {
    if (ref.current) {
      const container = ref.current;
      const children = Array.from(container?.children || []);
      const childrenWidth = children.reduce((a, b) => a + b.getBoundingClientRect().width, 0);
      const refWidth = container?.getBoundingClientRect().width || 0;
      setIsCut(childrenWidth > refWidth);
    }
  }, [children, ref]);

  return (
    <span
      ref={ref}
      className={cn(s.component, className, isCut && s[replaceBehavior])}
      data-testid="text-container"
    >
      {children}
    </span>
  );
};
